module.exports = __webpack_public_path__ + "frontend/images/favicons/mstile-310x310.png?2d80426f1d9d84d2bb0932f0d94d271e";